import React, { useState }       from 'react';
import PropTypes   from 'prop-types';
import { Button, Dropdown, Confirm }  from 'semantic-ui-react';

import OrganizationUserResource            from 'resources/admin/OrganizationUserResource';
import useOrganizationFetcher     from 'hooks/useOrganizationFetcher';


// -----------------------------------------------------
// Helpers
// -----------------------------------------------------

async function archiveHandler({ userId, organizationId, archive }) {
  const params  = { organization_id: organizationId, id: userId };

  const response = await archive(params, {});

  if(response.id) {
    window.location.reload(true);
  }
}

// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

const ArchiveButton = ({ userId, orgOptions }) => {
  const [ confirmOpen, setConfirmOpen ] = useState(false);
  const [ organizationId, setOrganizationId ] = useState(null);

  const archive         = useOrganizationFetcher(OrganizationUserResource.deleteShape());
  const handleArchive   = (e, { value }) => {
    setConfirmOpen(true);
    setOrganizationId(value);
  };

  const handleCancelArchive = () => {
    setConfirmOpen(false);
    setOrganizationId(null);
  };

  const handleConfirmArchive = () => {
    setConfirmOpen(false);
    archiveHandler({ userId, organizationId, archive });
  };

  if(orgOptions.length === 1) {
    const [ option ]  = orgOptions;
    const { value }   = option;
    return (
      <>
        <Confirm open={ confirmOpen }
                  onCancel={ handleCancelArchive }
                  onConfirm={ handleConfirmArchive }
                  content={ 'Are you sure you want to archive this user?' }
                  confirmButton={ 'Archive' }
                  cancelButton={ 'Cancel' } />
        <Button floated={ 'right' }
                value={ value }
                onClick={ handleArchive }>Archive</Button>
      </>
    );
  } else if(orgOptions.length > 1) {
    return (
      <>
        <Confirm open={ confirmOpen }
                  onCancel={ handleCancelArchive }
                  onConfirm={ handleConfirmArchive }
                  content={ 'Are you sure you want to archive this user?' }
                  confirmButton={ 'Archive' }
                  cancelButton={ 'Cancel' } />
        <Dropdown style={{ float: 'right' }} text='Archive' button>
          <Dropdown.Menu direction='left'>
            {
              orgOptions.map(({ value, text }) => (
                <Dropdown.Item  key={ value }
                                value={ value }
                                onClick={ handleArchive }>

                  { text }
                </Dropdown.Item>
              ))
            }
          </Dropdown.Menu>
        </Dropdown>
      </>
    );
  } else {
    return null;
  }

};

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

ArchiveButton.propTypes = {
  userId: PropTypes.number,
  orgOptions: PropTypes.array
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

export default ArchiveButton;
